import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStepSupportingDocuments = (state) => state.get('stepSupportingDocuments');

const makeSelectStepSupportingDocuments = () => createSelector(
  selectStepSupportingDocuments,
  (stepSupportingDocumentsState) => ({
    attachDocuments: mapWithDefault(stepSupportingDocumentsState, () => stepSupportingDocumentsState.getIn(['form', 'attachDocuments']).toJS(), ''),
    uploadPercentage: mapWithDefault(stepSupportingDocumentsState, () => stepSupportingDocumentsState.getIn(['form', 'uploadPercentage']), ''),
    progressBarVisibility: mapWithDefault(stepSupportingDocumentsState, () => stepSupportingDocumentsState.getIn(['form', 'progressBarVisibility']), ''),
    showWarningMissingRequiredDocument: mapWithDefault(stepSupportingDocumentsState, () => stepSupportingDocumentsState.getIn(['form', 'showWarningMissingRequiredDocument']), ''),
    warningMissingRequiredDocument: mapWithDefault(stepSupportingDocumentsState, () => stepSupportingDocumentsState.getIn(['form', 'warningMissingRequiredDocument']), ''),
  })
);

const makeSelectStepSupportingDocumentsErrors = () =>
  createSelector(selectStepSupportingDocuments, (state) => state.get('errors'));

export {
  makeSelectStepSupportingDocuments,
  makeSelectStepSupportingDocumentsErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepSupportingDocuments/selectors.js